import { render, staticRenderFns } from "./UpdateIndustrialSectorPopUp.vue?vue&type=template&id=2b7238fe&scoped=true&"
import script from "./UpdateIndustrialSectorPopUp.vue?vue&type=script&lang=js&"
export * from "./UpdateIndustrialSectorPopUp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7238fe",
  null
  
)

export default component.exports